"use client";
import Recommend from "@/common-components-src/js/recommend/index";
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25325'
type Props = {
    skus: string,
    categoryId: string,
}

export default function RecommendList({ skus, categoryId }: Props) {
    return <Recommend
        sceneCode="product_detail_page"
        mainSkus={skus}
        c3Id={categoryId}
        trackParams={{
            RecomSku_Expo: EXPOSURE_RECORD.Productdetail_RecomSku_Expo,
            RecomSku_Tab_Expo: EXPOSURE_RECORD.Productdetail_RecomSku_Tab_Expo,
            RecomSku_Addcart_Expo: EXPOSURE_RECORD.Productdetail_RecomSku_Addcart_Expo,
            productClick: sendClickTrack.Productdetail_RecomSku,
            tabClick: sendClickTrack.Productdetail_RecomSku_Tab,
            addCartClick: sendClickTrack.Productdetail_RecomSku_Addcart,
        }}
    />
}
